"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMediaState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    SMALL: 768,
    MEDIUM: 1200,
    isSmall: false,
    isMedium: false,
};
var mediaQuerySlice = (0, toolkit_1.createSlice)({
    name: 'mediaQuery',
    initialState: initialState,
    reducers: {
        setMediaState: function (state, action) {
            state.isSmall = action.payload.isSmall;
            state.isMedium = action.payload.isMedium;
        },
    },
});
exports.setMediaState = mediaQuerySlice.actions.setMediaState;
exports.default = mediaQuerySlice.reducer;
